// Admin-app signup. Hand-written for the same reason as
// `getGoogleSigninUrl` in ./auth.ts — the orval-generated client is
// regenerated from a checked-in swagger.json, and this endpoint is
// newer than that file.

import { apiClient } from '@/lib/axios';

export interface AdminSignupRequest {
  email: string;
  password: string;
  // `| undefined` is required under exactOptionalPropertyTypes: the
  // signup form builds these with `value.trim() || undefined` rather
  // than conditionally spreading keys. axios drops undefined values
  // during JSON serialisation, so the field is absent on the wire —
  // which is what the Zod `.optional()` on the server expects (an
  // explicit empty string would fail its min(1)).
  firstName?: string | undefined;
  lastName?: string | undefined;
  /** IANA zone. The API defaults to UTC when omitted. */
  timezone?: string | undefined;
}

export interface AdminSignupResponse {
  token: string;
  isAdmin: boolean;
  /** Always true, but grants nothing now — see userRepository's note. */
  isVideoEditor: boolean;
}

/**
 * POST /admin/auth/signup — public (no JWT); creates a user in the same
 * `users` table the Flutter app signs up into, with `isVideoEditor` set.
 * Rate-limited server-side to 20 attempts / 15 min per IP.
 */
export const adminSignup = async (body: AdminSignupRequest): Promise<AdminSignupResponse> => {
  const { data } = await apiClient.post<AdminSignupResponse>('/admin/auth/signup', body);
  return data;
};
